import React, { useState } from 'react';

interface AdminAccountModalProps {
  onClose: () => void;
  onSubmit: (username: string, password: string) => Promise<void>;
}

export function AdminAccountModal({ onClose, onSubmit }: AdminAccountModalProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = username.trim();
    if (trimmed.length < 3) {
      setFormError('Der Benutzername muss mindestens 3 Zeichen haben.');
      return;
    }
    if (password.length < 8) {
      setFormError('Das Passwort muss mindestens 8 Zeichen haben.');
      return;
    }
    if (password !== confirm) {
      setFormError('Die Passwörter stimmen nicht überein.');
      return;
    }
    setFormError(null);
    setSubmitting(true);
    try {
      await onSubmit(trimmed, password);
    } catch (err) {
      setFormError(err instanceof Error ? err.message : 'Konto konnte nicht angelegt werden.');
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content game-create-modal"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-account-title"
      >
        <div className="modal-header">
          <h2 id="admin-account-title">👑 Neues Admin-Konto</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Schließen">✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {formError && <p className="form-error" role="alert">{formError}</p>}
            <div className="form-group">
              <label htmlFor="admin-account-username">Benutzername *</label>
              <input
                id="admin-account-username"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoComplete="off"
                autoFocus
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="admin-account-password">Passwort *</label>
              <input
                id="admin-account-password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
            <div className="form-group">
              <label htmlFor="admin-account-confirm">Passwort wiederholen *</label>
              <input
                id="admin-account-confirm"
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                autoComplete="new-password"
                required
                minLength={8}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="medieval-button cancel-btn" onClick={onClose} disabled={submitting}>
              Abbrechen
            </button>
            <button type="submit" className="medieval-button create-btn" disabled={submitting}>
              {submitting ? 'Erstelle…' : 'Konto anlegen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
